export const dynamicValidationMessages: {
  pattern: RegExp;
  key: string;
  params?: string[];
}[] = [
  {
    pattern: /^Record\(s\) created successfully\s*$/i,
    key: "recordsCreated",
  },
  {
    pattern: /^Record\(s\) Deleted successfully\s*$/i,
    key: "recordsDeleted",
  },
  {
    pattern: /^Record\(s\) updated successfully\s*$/i,
    key: "recordsUpdated",
  },
  {
    pattern:
      /^End date\(([^)]+)\) should be greater than Begin date\(([^)]+)\)$/,
    key: "endDateShouldBeGreaterThanBeginDate",
    params: ["journal_end_date", "journal_begin_date"],
  },
  {
    pattern: /^Journal Begin date\(([^)]+)\) must be atleast 5 years prior$/i,
    key: "beginDateWithin5Years",
    params: ["journal_begin_date"],
  },
  {
    pattern: /This Journal is Referenced in setup\(s\) (.+)/,
    key: "journalReferenced",
    params: ["journal_id"],
  },
  {
    pattern: /Account Sub type\((.+)\) already exists for this company/,
    key: "duplicateAccountSubType",
    params: ["sub_type"],
  },
  {
    pattern: /End date should be greater than begin date/,
    key: "endDateGreaterThanBeginDate",
    params: [],
  },
  {
    pattern: /Begin Date must be between current date to past 5 years/,
    key: "beginDateRangeValidation",
    params: [],
  },
  {
    pattern: /This Account is Referenced in setup\(s\) (.+)/,
    key: "accountReferencedInSetups",
    params: ["setups"],
  },
  {
    pattern: /Duplicate Report Number\((.+)\)/,
    key: "duplicateCashInBankReportNumber",
    params: ["report_number"],
  },
  {
    pattern: /Duplicate\((.+)\) Recurring Jrnl Reference Number/,
    key: "recurringJournalEntriesDuplicateReference",
    params: ["recurring_je_reference_number", "journal_id"],
  },
  {
    pattern: /Inconsistent value for field (.+) in distribution Accounts./,
    key: "distributionAccountsInconsistent",
    params: ["distribution"],
  },
  {
    pattern:
      /Distribution percentage should be equal to 100 for the allocation account \((.+)\)/,
    key: "distributionPercentageInvalid",
    params: ["allocation_account"],
  },
  {
    pattern:
      /Record already exists. Cash Receipts Payment Types setup for store and enterprise should be one./,
    key: "duplicatePaymentType",
    params: [],
  },
  {
    pattern:
      /Cut off date\((.+)\) must be between current month enddate and next month end date/,
    key: "invalidCutoffDate",
    params: ["cutoff_datetime"],
  },
  {
    pattern:
      /Record already exists. Cash Receipts Defaults setup for store and enterprise should be one./,
    key: "duplicateCashReceiptsDefaults",
    params: [],
  },
  {
    pattern:
      /Record already exists\. PO Approval Limit should contains only one for an enterprise/,
    key: "poRoleLevelInfoUnique",
    params: [],
  },
  {
    pattern: /Duplicate\(%s\) UOM Code/,
    key: "poUomCodeUnique",
    params: ["uom_cd"],
  },
];
